import locales from './locales';
import {
  accidentCoverage,
  computerBreakage,
  debtRecovery,
  fromPartners,
  healthCostsAbroad,
  hospitalization,
  legalAssistance,
  mobileScreen,
  paymentFraud,
  phishing,
  purchaseProtection,
  rentalVehicle,
  transportDelay,
  warrantyExtension,
} from './routes';
import { OfferId, OfferWithLink } from './types';

const offers: Record<OfferId, OfferWithLink> = {
  accidentCoverage: {
    ...locales.offers.accidentCoverage,
    icon: 'accident',
    path: accidentCoverage,
  },
  computerBreakage: {
    ...locales.offers.computerBreakage,
    icon: 'laptop',
    path: computerBreakage,
  },
  debtRecovery: {
    ...locales.offers.debtRecovery,
    icon: 'loan',
    path: debtRecovery,
  },
  fromPartners: {
    ...locales.offers.fromPartners,
    icon: 'more',
    path: fromPartners,
  },
  healthCostsAbroad: {
    ...locales.offers.healthCostsAbroad,
    icon: 'accident',
    path: healthCostsAbroad,
  },
  hospitalization: {
    ...locales.offers.hospitalization,
    icon: 'home',
    path: hospitalization,
  },
  legalAssistance: {
    ...locales.offers.legalAssistance,
    icon: 'legal',
    path: legalAssistance,
  },
  mobileScreen: {
    ...locales.offers.mobileScreen,
    icon: 'phone-screen',
    path: mobileScreen,
  },
  paymentFraud: {
    ...locales.offers.paymentFraud,
    icon: 'card-recto',
    path: paymentFraud,
  },
  phishing: {
    ...locales.offers.phishing,
    icon: 'shield',
    path: phishing,
  },
  purchaseProtection: {
    ...locales.offers.purchaseProtection,
    icon: 'cash',
    path: purchaseProtection,
  },
  rentalVehicle: {
    ...locales.offers.rentalVehicle,
    icon: 'vehicle',
    path: rentalVehicle,
  },
  transportDelay: {
    ...locales.offers.transportDelay,
    icon: 'clock-late',
    path: transportDelay,
  },
  warrantyExtension: {
    ...locales.offers.warrantyExtension,
    icon: 'warranty',
    path: warrantyExtension,
  },
};

export default offers;
